const e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M15.34 9.97a.75.75 0 0 1 0 1.06l-3.52 3.52a.75.75 0 0 1-1.065-.005l-2.04-2.08a.75.75 0 0 1 1.07-1.05l1.51 1.54L14.28 9.97a.75.75 0 0 1 1.06 0"/><path fill-rule="evenodd" d="M12 22.5c5.799 0 10.5-4.701 10.5-10.5S17.799 1.5 12 1.5 1.5 6.201 1.5 12 6.201 22.5 12 22.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0" clip-rule="evenodd"/></svg>';
export {
  e as w
};
